//===================================
// Gallery full
//===================================

import { SplideGallery } from "../includes/splide";

SplideGallery('.gallery-full .splide', {
  type: 'loop',
  autoplay: true,
  interval: 5000,
  arrows: false,
  pagination: false,
});